export default __webpack_public_path__ + "static/media/IMAGE_11.37694ff0.png";